import faqConfig from './ml-faq.json';

const faqJson = JSON.parse(JSON.stringify(faqConfig));

function single(entries) {
    if (entries.length !== 1) {
        throw new Error(`Expected a single element but got ${entries}`);
    }
    return entries[0];
}

export default {
    getFaqJson: () => {
        return faqJson;
    },
    getAllSections: () => {
        return faqJson.sections;
    },
    getTopic: (id) => {
        return faqJson.sections.map((section) => section.topics)
            .reduce((flat, item) => flat.concat(item), [])
            .find((topic) => topic.id === id);
    },
    getLinkContent: (id) => {
        const sectionContent = faqJson.sections
            .filter((section) => section.id === id)
            .map((section) => section.title);

        const topicContent = faqJson.sections.map((section) => section.topics)
            .reduce((flat, item) => flat.concat(item), [])
            .filter((topic) => topic.id === id)
            .map((topic) => topic.inlineQuestion);

        return single(sectionContent.concat(topicContent));
    }
};
